import styled from 'styled-components';
import { mediaQueryLaptopMin } from 'styles';

export const Wrapper = styled.aside`
  width: 100%;

  @media ${mediaQueryLaptopMin} {
    width: 300px;
  }
`;
